export default {
  methods: {
    getDisbursementAmt (row) {
      var pln = JSON.parse(row.plan)
      // var fpi = 0
      // var gstAmt = 0
      // if (pln.planType !== 'normal') {
      //   if (pln.fileChargeIncludeAmt === 'true') {
      //     fpi += row.fileCharge ? row.fileCharge : parseInt(pln.fileCharge)
      //   }
      //   if (pln.processingFeeIncludeAmt === 'true') {
      //     fpi += row.processingFee ? row.processingFee : parseInt(pln.processingFee)
      //   }
      //   if (pln.insuranceFeeIncludeAmt === 'true') {
      //     fpi += row.insuranceFee ? row.insuranceFee : parseInt(pln.insuranceFee)
      //   }
      //   if (pln.includeGst === 'true') {
      //     gstAmt = fpi * 18 / 100
      //     fpi += parseInt(gstAmt)
      //   }
      //   this.planAmt = row.loanAmount ? row.loanAmount + fpi : pln.amount + fpi
      //   this.DisbursementAmt = row.loanAmount ? row.loanAmount : pln.amount
      // } else {
      //   this.planAmt = row.loanAmount ? row.loanAmount : pln.amount
      //   this.DisbursementAmt = row.loanAmount ? row.loanAmount : pln.amount
      // }
      return row.loanAmount ? row.loanAmount : pln.amount
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/GetDisbursementAmount.js